import React, { memo } from "react";

const GiftIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.79273 1.05083C6.73091 1.03992 4.72364 3.02537 5.64 5.49083H2.18182C1.60316 5.49083 1.04821 5.7207 0.63904 6.12987C0.22987 6.53904 0 7.09399 0 7.67264V9.85446C0 10.1438 0.114935 10.4213 0.31952 10.6259C0.524105 10.8304 0.801582 10.9454 1.09091 10.9454H10.9091V7.67264H13.0909V10.9454H22.9091C23.1984 10.9454 23.4759 10.8304 23.6805 10.6259C23.8851 10.4213 24 10.1438 24 9.85446V7.67264C24 7.09399 23.7701 6.53904 23.361 6.12987C22.9518 5.7207 22.3968 5.49083 21.8182 5.49083H18.36C19.6364 1.92355 14.8364 -0.596447 12.6218 2.47992L12 3.30901L11.3782 2.4581C10.6909 1.48719 9.74182 1.06174 8.79273 1.05083ZM8.72727 3.30901C9.69818 3.30901 10.1891 4.48719 9.50182 5.17446C8.81455 5.86174 7.63636 5.37083 7.63636 4.39992C7.63636 4.11059 7.7513 3.83311 7.95588 3.62853C8.16047 3.42394 8.43795 3.30901 8.72727 3.30901ZM15.2727 3.30901C16.2436 3.30901 16.7345 4.48719 16.0473 5.17446C15.36 5.86174 14.1818 5.37083 14.1818 4.39992C14.1818 4.11059 14.2968 3.83311 14.5013 3.62853C14.7059 3.42394 14.9834 3.30901 15.2727 3.30901ZM1.09091 12.0363V20.7636C1.09091 21.3422 1.32078 21.8972 1.72995 22.3063C2.13912 22.7155 2.69407 22.9454 3.27273 22.9454H20.7273C21.3059 22.9454 21.8609 22.7155 22.2701 22.3063C22.6792 21.8972 22.9091 21.3422 22.9091 20.7636V12.0363H13.0909V20.7636H10.9091V12.0363H1.09091Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { GiftIcon };
